import { FC } from "react";
import { Pragraph } from "../Pragraph/Pragraph";

export const FifthSection: FC = () => {
  return (
    <li>
      <div>5. お問合せ窓⼝</div>
      <Pragraph>
        ご意⾒、ご質問、苦情のお申出その他個⼈情報の取扱いに関するお問合せは、下記の窓⼝までご連絡ください。
      </Pragraph>
      <dl className="px-[2em] py-[1em]">
        <div className="flex">
          <dt className="shrink-0">住所：</dt>
          <dd>
            〒101-0051 東京都千代⽥区神⽥神保町２丁⽬１４−１１ <br />
            朝⽇神保町プラザ 909
          </dd>
        </div>
        <div className="flex">
          <dt className="shrink-0">e-mail：</dt>
          <dd>info@kdotdev.com</dd>
        </div>
        <div className="flex">
          <dt className="shrink-0">電話番号：</dt>
          <dd>080-5237-6108 (受付時間：9：30〜17：00 祝⽇を除きます。)</dd>
        </div>
      </dl>
    </li>
  );
};
